import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import FellowshipMain from './FellowshipMain';

const Fellowship = () => {
  return (
    <>
        <HeaderSeven />
        <FellowshipMain />
        <Footer />
    </>
  );
};

export default Fellowship;
